export default __webpack_public_path__ + "static/media/DVS.c18e43f1.svg";